// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import type {
  CastReceiverContext,
  CastReceiverOptions,
} from 'chromecast-caf-receiver/cast.framework';
// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import {
  EditTracksInfoRequestData,
  LoadRequestData,
} from 'chromecast-caf-receiver/cast.framework.messages';
import UnifiedPlayer from '@tv2-player/unifiedplayer/src/core/UnifiedPlayer';
import { createAction, createFilter } from './ExtensionPoints';
import { makeMediaObject } from '../services/media';
import type { PlaybackConfig } from '../types/chromecast-caf-receiver/cast.framework';
import { OverlayManager } from '../overlays';
import { CustomMessageEvent } from '../types';

export const bootstrapAction = createAction<[CastReceiverContext]>();
export const beforeFetchMediaAction = createAction<[LoadRequestData]>();
export const errorAction = createAction<[any]>();
export const customMessageAction = createAction<[CustomMessageEvent]>();

export const loadRequestFilter = createFilter<LoadRequestData>();
export const playbackInfoHandlerFilter = createFilter<PlaybackConfig, [LoadRequestData]>();
export const editTracksInfoFilter = createFilter<EditTracksInfoRequestData>();
export const playbackConfigFilter = createFilter<PlaybackConfig, [LoadRequestData]>();
export const mediaFilter = createFilter<ReturnType<typeof makeMediaObject>, [string]>();
export const appOptionsFilter = createFilter<CastReceiverOptions>();
export const playerFilter = createFilter<UnifiedPlayer>();
export const overlayManagerFilter = createFilter<OverlayManager>();
